import React, { useState, useEffect, MutableRefObject } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import { PATTERNS } from "../../util/patterns";
import { cardBrandList } from "../../util/CommonLists";
import i18nService from "../../util/Internationalization/i18n/i18n";
import { validateCardExpiry } from "../../util/common";
interface IProps {
    closeDialog: any;
    sendBillingData: any;
}
interface cardState {
    cardType: {
        options: string[],
        selection: string,
        readOnly: boolean,
    },
    nameOnCard: string,
    cardNumber: string,
    expDateMo: string,
    expDateYr: string,
    securityCode: string,
    billingZip: string,

}
const BillingInfoIDFUser: React.FunctionComponent<IProps> = (props) => {
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const { t: tLang } = useTranslation();
    const [cardInfoState, setCardInfoState] = useState<cardState>({
        cardType: {
            options: [],
            selection: "",
            readOnly: true,
        },
        nameOnCard: "",
        cardNumber: "",
        expDateMo: "",
        expDateYr: "",
        securityCode: "",
        billingZip: "",
    });
    const [billingZip, setZipCode] = useState(i18nService.get("ZipCode"));
    const { register, handleSubmit, errors, setValue, setError, clearErrors, control, watch } = useForm({
        mode: "all",
        shouldFocusError: true,
        reValidateMode: "onChange",
    });

    useEffect(() => {
        if (accountInfo?._personalAccountInformation) {
            var fullname = accountInfo?._personalAccountInformation?.firstName + ' ' + accountInfo?._personalAccountInformation?.lastName;
            setCardInfoState({ ...cardInfoState, nameOnCard: fullname });
        }
    }, []);

    let keyPressed: number;
    const keyCode = (e: any) => {
        keyPressed = e.keyCode;
    };
    const addMask = (e: any) => {
        e.preventDefault();
        if (e.target.value.length === 2 && keyPressed !== 8 && keyPressed !== 46) {
            e.target.value = e.target.value + "/";
        }
        setCardExpDate(e.target.value);
    };

    const setCardExpDate = (expDate: string) => {
        expDate = expDate.replace("/", "");
        setCardInfoState({ ...cardInfoState, expDateMo: expDate.substring(0, 2), expDateYr: expDate.substring(2, 4) });
    };

    const validateSecurityCode = {
        invalid: (val: any) => {
            if (cardInfoState.cardType?.selection === "AMEX") {
                return /^$|^(\d{4})$/.test(val);
            }
            return /^$|^(\d{3})$/.test(val);
        },
    };

    const onClick = () => {
        if (cardInfoState) {
            props.sendBillingData(cardInfoState);
            props.closeDialog();
        }
    }
    const RefreshAndClose = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="coins" />
                </div>
                <h1>
                    {tLang("manageAccount.protectionPlan.billingInformation.title")}
                </h1>
            </div>
            <form id="protection-plan-billing-form-container" onSubmit={handleSubmit(onClick)}>
                <fieldset className="form-row">
                    <div className="row">
                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                            <legend className="legend-label">
                                <label htmlFor="label-cardholder-name">
                                    {" "}
                                    {tLang("manageAccount.protectionPlan.billingInformation.label.cardholderName")}
                                    <span className="required" title="Mandatory">*</span>
                                </label>
                            </legend>
                        </div>
                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                            <div className="row">
                                <div className="col-xs-12 col-no-gutter">
                                    <div className={`form-row row ${errors["cardholderName"] && "status-error"}`}>
                                        <div className="form-input col-xs-12 col-no-gutter">
                                            <input
                                                type="text"
                                                ref={register({ required: true, pattern: PATTERNS.CARDHOLDERNAMEBILLINGINFOIDFUSER.pattern, maxLength: 30 })}
                                                className="inputbox"
                                                id="label-cardholder-name"
                                                defaultValue={cardInfoState.nameOnCard}
                                                onChange={(e) => setCardInfoState({ ...cardInfoState, nameOnCard: e.target.value })}
                                                placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.cardholderNameIDFUser")}
                                                name="cardholderName"
                                                aria-required="true"
                                            />                                 
                                            {errors["cardholderName"] && errors["cardholderName"].type === "required" && (
                                                <span className="form-error">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.cardholderName.required")}
                                                </span>
                                            )}
                                            {errors["cardholderName"] && errors["cardholderName"].type === "pattern" && (
                                                <span className="form-error">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.cardholderName.invalidMsgIDF")}
                                                </span>
                                            )}
                                            {errors["cardholderName"] && errors["cardholderName"].type === "maxLength" && (
                                                <span className="form-error">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.cardholderName.maxLength")}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset className="form-row inline">
                    <div className="row">
                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                            <legend className="legend-label">
                                {" "}
                                <label htmlFor="label-card-type">{tLang("manageAccount.protectionPlan.billingInformation.label.cardType")}
                                    <span className="required" title="Mandatory">*</span>
                                </label>
                            </legend>
                        </div>
                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                            <div className="row">
                                <div className="col-xs-12 col-no-gutter">
                                    <div className={`form-row row ${errors["cardType"] && "status-error"}`}>
                                        <div className="form-input col-xs-12 col-no-gutter">
                                            <select
                                                name="cardType"
                                                className="inputbox"
                                                id="label-card-type"
                                                defaultValue="Choose Type"
                                                ref={register({ required: true })}
                                                onChange={(e) =>
                                                    setCardInfoState({
                                                        ...cardInfoState,
                                                        cardType: {
                                                            ...cardInfoState.cardType, selection: e.target.value, options: [e.target.value]
                                                        },
                                                    })
                                                }
                                                aria-required="true"
                                            >
                                                {cardBrandList.map((val: any) => (
                                                    <option key={val.value} value={val.value}>
                                                        {val.name}
                                                    </option>
                                                ))}

                                            </select>
                                            {errors["cardType"] && errors["cardType"].type === "required" && (
                                                <span className="form-error">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.cardType.required")}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset className="form-row">
                    <div className="row">
                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                            <legend className="legend-label">
                                {" "}
                                <label htmlFor="label-card-number">
                                    {tLang("manageAccount.protectionPlan.billingInformation.label.cardNumber")}
                                    <span className="required" title="Mandatory"> *</span>
                                </label>
                            </legend>
                        </div>
                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                            <div className="row">
                                <div className="col-xs-12 col-no-gutter">
                                    <div className={`form-row row ${errors["cardNumber"] && "status-error"}`}>
                                        <div className="form-input col-xs-12 col-no-gutter">
                                            <input
                                                type="text"
                                                ref={register({ required: true, pattern: /^$|^(\d{15,16})$/ })}
                                                className="inputbox"
                                                id="label-card-number"
                                                defaultValue=""
                                                onChange={(e) => setCardInfoState({ ...cardInfoState, cardNumber: e.target.value })}
                                                placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.cardNumber")}
                                                name="cardNumber"
                                                maxLength={16}
                                                aria-required="true"
                                            />
                                            {errors["cardNumber"] && errors["cardNumber"].type === "required" && (
                                                <span className="form-error">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.cardNumber.required")}
                                                </span>
                                            )}
                                            {errors["cardNumber"] && errors["cardNumber"].type === "pattern" && (
                                                <span className="form-error">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.cardNumber.pattern")}
                                                </span>
                                            )}                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset className="form-row">
                    <div className="row">
                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                            <legend className="legend-label">
                                <label htmlFor="expirationDate">
                                    {" "}
                                    {tLang("manageAccount.protectionPlan.billingInformation.label.expirationDate")}{" "}
                                    <span className="required" title="Mandatory"> *</span>
                                </label>
                            </legend>
                        </div>
                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                            <div className="row">
                                <div className="col-xs-12 col-no-gutter">
                                    <div className={`form-row row ${errors["expirationDate"] && "status-error"}`}>
                                        <div className="form-input col-xs-12 col-no-gutter">
                                            <input
                                                name="expirationDate"
                                                id="expirationDate"
                                                type="text"
                                                onKeyDown={keyCode}
                                                onChange={addMask}
                                                className="inputbox"
                                                ref={register({
                                                    required: true,
                                                    maxLength: 5,
                                                    pattern: /(0[1-9]|1[012])[/]?([0-9][1-9]|[1-9][0-9])/,
                                                    validate: (value) => {
                                                        if (value.length === 5) {
                                                            const expireDate = value.split("/");
                                                            return validateCardExpiry(expireDate[0], expireDate[1]);
                                                        }
                                                        return true;
                                                    },
                                                })}
                                                placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.expirationDate")}
                                                maxLength={5}
                                                aria-required="true"
                                            />
                                            {errors["expirationDate"] && errors["expirationDate"].type === "required" && (
                                                <span className="form-error">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.expirationDate.required")}
                                                </span>
                                            )}
                                            {errors["expirationDate"] && errors["expirationDate"].type === "pattern" && (
                                                <span className="form-error">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.expirationDate.pattern")}
                                                </span>
                                            )}
                                            {errors["expirationDate"] && errors["expirationDate"].type === "validate" && (
                                                <span className="form-error">{`${tLang(
                                                    "manageAccount.protectionPlan.billingInformation.validation.expirationDate.invalid"
                                                )} ${partnerPhoneNumber}.`}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset className="form-row">
                    <div className="row">
                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                            <legend className="legend-label">
                                <label htmlFor="label-security-code">
                                    {tLang("manageAccount.protectionPlan.billingInformation.label.securityCode")}
                                    <span className="required" title="Mandatory">*</span>
                                </label>
                            </legend>
                        </div>
                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                            <div className="row">
                                <div className="col-xs-12 col-no-gutter">
                                    <div className={`form-row row ${errors["securityCode"] && "status-error"}`}>
                                        <div className="form-input col-xs-12 col-no-gutter">
                                            <input
                                                type="password"
                                                maxLength={cardInfoState.cardType?.selection === "AMEX" ? 4 : 3}
                                                ref={register({ required: true, validate: validateSecurityCode })}
                                                className="inputbox"
                                                id="label-security-code"
                                                defaultValue={cardInfoState.securityCode}
                                                onChange={(e) => setCardInfoState({ ...cardInfoState, securityCode: e.target.value })}
                                                placeholder="CVV"
                                                name="securityCode"
                                                aria-required="true"
                                            />
                                            {errors["securityCode"] && errors["securityCode"].type === "required" && (
                                                <span className="form-error">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.securityCode.required")}
                                                </span>
                                            )}
                                            {errors["securityCode"] && errors["securityCode"].type === "invalid" && (
                                                <span className="form-error">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.securityCode.invalid")}{" "}
                                                    {cardInfoState.cardType?.selection === "AMEX" ? "4" : "3"}{" "}
                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.securityCode.digit")}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset className="form-row inline">
                    {accountInfo?.country !== null && accountInfo?.country === "CA" ? (
                        <div className="row">
                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                <legend className="legend-label">
                                    {" "}
                                    <label htmlFor="label-address-zipcode">Postal Code</label>
                                    <span className="required" title="Mandatory">*</span>
                                </legend>
                            </div>

                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                <div className="row">
                                    <div className="col-xs-12 col-no-gutter">
                                        <div className={`form-row row ${errors["zipcode"] && "status-error"}`}>
                                            <div className="form-input col-xs-12 col-no-gutter">
                                                <input
                                                    type="text"
                                                    name="zipcode"
                                                    className="inputbox"
                                                    onChange={(e) => {
                                                        setCardInfoState({ ...cardInfoState, billingZip: e.target.value });
                                                        clearErrors("billingAddress");
                                                    }}
                                                    defaultValue={cardInfoState.billingZip}
                                                    id="label-address-zipcode"
                                                    ref={register({ required: true, pattern: PATTERNS.POSTALCODE.pattern })}
                                                    placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.postalCode")}
                                                    aria-required="true"
                                                />
                                                {errors["zipcode"] && errors["zipcode"].type === "required" && (
                                                    <span className="form-error">
                                                        {tLang("manageAccount.protectionPlan.billingInformation.validation.postalCode.required")}
                                                    </span>
                                                )}
                                                {errors["zipcode"] && errors["zipcode"].type === "pattern" && (
                                                    <span className="form-error">
                                                        "Please Enter a Valid Postal Code"
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                <legend className="legend-label">
                                    {" "}
                                    <label htmlFor="label-address-zipcode">{billingZip.Label}
                                        <span className="required" title="Mandatory">*</span>
                                    </label>
                                </legend>
                            </div>

                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                <div className="row">
                                    <div className="col-xs-12 col-no-gutter">
                                        <div className={`form-row row ${errors["zipcode"] && "status-error"}`}>
                                            <div className="form-input col-xs-12 col-no-gutter">
                                                    <input
                                                        type="text"
                                                        name="zipcode"
                                                        className="inputbox"
                                                        onChange={(e) => {
                                                            setCardInfoState({ ...cardInfoState, billingZip: e.target.value });
                                                            clearErrors("billingAddress");
                                                        }}
                                                        defaultValue={cardInfoState.billingZip}
                                                        id="label-address-zipcode"
                                                        ref={register({ required: true, pattern: PATTERNS.IDF_BILLING_PROFILE_ZIPCODE.pattern })}
                                                        placeholder={tLang("manageAccount.protectionPlan.billingInformation.placeholder.zipCodeIDF")}
                                                        aria-required="true"
                                                        maxLength={5}
                                                />
                                                {errors["zipcode"] && errors["zipcode"].type === "required" && (
                                                    <span className="form-error">
                                                        {tLang("manageAccount.protectionPlan.billingInformation.validation.zipCode.required")}
                                                    </span>
                                                )}
                                                {errors["zipcode"] && errors["zipcode"].type === "pattern" && (
                                                    <span className="form-error">
                                                            {PATTERNS.IDF_BILLING_PROFILE_ZIPCODE.message}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </fieldset>
                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                type="button"
                                className="btn-default btn-link btn-no-padding btn-no-border"
                                id="btn-cancel-protection-plan-billing"
                                onClick={() => {
                                    window.addToDataLayer({ event: "Protection Plan - Close billing info" });
                                    RefreshAndClose();
                                }}
                            >
                                <span className="btn-text">{tLang("manageAccount.protectionPlan.billingInformation.btn.cancel")}</span>
                            </button>
                        </div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                type="submit"
                                className="btn-default btn-primary"
                                id="btn-submit-update-billing"
                            >
                                <span className="btn-text">
                                    {tLang("manageAccount.protectionPlan.billingInformation.btn.save")}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </React.Fragment >

    );
}

export default BillingInfoIDFUser;
